import axios from "axios";
import { baseURL } from "../utils/URL";

const onGetOrgAudit = async (config: any) => {
  try {
    const response = await axios.get(`${baseURL}/audit`, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

const onGetauthuserNotifications = async (config: any) => {
  try {
    const response = await axios.get(`${baseURL}/notification/user`, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

export { onGetOrgAudit, onGetauthuserNotifications };
